import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConsolidacaoAplicacaoVO } from '../shared/model/.'

@Injectable({
  providedIn: 'root'
})
export class ObrigacaoAplicacaoService {

  private readonly endpoint = '/sepin-backend/rest/obrigacao-aplicacoes';

  constructor(private readonly http: McticHttpClient) {
  }

  obterConsolidacao(): Observable<ConsolidacaoAplicacaoVO> {
    return this.http.get<ConsolidacaoAplicacaoVO>(this.endpoint).pipe(map(o => o[0]));
  }

  salvarConsolidacao(obrigacao: any) {
    return this.http.post(this.endpoint, obrigacao);
  }

  atualizarConsolidacao(obrigacao: any) {
    return this.http.put(this.endpoint, obrigacao);
  }
}
